export default "__VITE_ASSET__6a44f70d__"